import Mains from '../src/mains/mains'
import './App.css';


const App = () => (
  <Mains key={window.location.href}/>
);

export default App;
